import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'

import { firstValueFrom, forkJoin, Observable, catchError, throwError } from "rxjs"
import { map } from 'rxjs/operators';



// Environment varialbes
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(
    private _http: HttpClient
  ) { }


  executeHttpPostMethod(urlString:string, bodyDictionary:any){   
    this._http.post<any>(urlString, bodyDictionary).subscribe(data => {
    });
  }


  async executeHttpPostMethodAndWaitResponse(urlString:string, bodyDictionary:any){   
    try{
      let result = await  this._http.post<any>(urlString, bodyDictionary).toPromise()
      return result
    }catch (error){
      console.error(error);
      let customErrorCode = error['error']['error']
      return {'resultOk': false, 'error':customErrorCode}
    }
  }

  async executeHttpPostMethodSigned(urlString:string, bodyDictionary:any, idToken:string){   
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${idToken}`, 
        //'Content-Type': 'application/x-www-form-urlencoded'
        // 'X-Serverless-Authorization': `Bearer ${idToken}`, 
      }),
    };
    try{
      let result = await this._http.post<any>(urlString, bodyDictionary, httpOptions).toPromise()
      result['resultOk'] = true // TODO: TBD - Just to keep the logic. Need to be improved in the entire code
      return result
    }catch (error){
      console.error(error);
      let customErrorCode = error['error']['error']
      return {'resultOk': false, 'error':customErrorCode}
    }
  }










  executeHttpPostMethodSignedAsync(urlString:string, bodyDictionary:any, idToken:string){   
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Bearer ' + idToken
        //'Authorization': idToken
      }),
    };
    this._http.post<any>(urlString, bodyDictionary, httpOptions).subscribe(data => {
    });
  }





  // ----- File uploading using our custom uploading function ----- //

  // Upload file to storage
  // TODO: TBD -- Update this --- No need to generate signed url from the front end -------------------------------
  async uploadFile(file, objectPath, accessToken, userEmail) {
    // Custom Cloud Function Uploading method
    let userIdToken = accessToken.toString()
    let formData = new FormData();
    formData.append('userEmail', userEmail)
    //formData.append('userKeyCode', userIdToken)
    formData.append('file', file)
    formData.append('filePath', objectPath)
    let urlString = environment.googleCloudRun.generic.uploadFile
    let resultDict = await this.executeHttpPostMethodSigned(urlString, formData, userIdToken)
    return resultDict
  }




  // ----- File downloading from url as File type (for loading projects) ----- //
  
  downloadFile(url: string): Observable<Blob> {
    return this._http.get(url, { responseType: 'blob' });
  }

  convertBlotToFile(blob: Blob, fileName: string): File {
    const archivo = new File([blob], fileName, {
      type: blob.type,
    });
    return archivo;
  }

  async downloadAsFileFromUrl(urls: string[]): Promise<File[]> {
    const observables = urls.map((url, index) =>
      this.downloadFile(url).pipe(
        map(blob => this.convertBlotToFile(blob, `image_${index}`))
      )
    );
    // Wait for all downloads to be completed
    const archivos = await firstValueFrom(forkJoin(observables));
    return archivos;
  }
  



}
